<template>
  <section class="section license">
    <div class="license-content">
      <div class="license__select">
        <ContentNavigation v-slot="{ navigation }" :query="licenseQuery">
          <BaseSelect
            v-if="navigation?.[0]?.children?.[0]?.children"
            :options="setSelectOptions(navigation?.[0]?.children[0].children)"
            :model-value="selectedFile"
            styled
            arrow
            @change="onSelectFile"
          >
            <template #value>
              <ContentDoc :path="props.documentPath" :head="false">
                <template v-slot="{ doc }">
                  {{ getDate(doc.date) }}
                </template>
                <template #not-found>
                  {{ $t("Document not found") }}
                </template>
              </ContentDoc>
            </template>
            <template #option="option">
              <ContentDoc
                v-slot="{ doc }"
                :path="option.option.id"
                :head="false"
              >
                <LocLink :to="option.option.id">
                  {{ getDate(doc.date) }}
                </LocLink>
              </ContentDoc>
            </template>
          </BaseSelect>
        </ContentNavigation>
      </div>
      <div class="license-document">
        <ContentDoc :path="props.documentPath" :head="false">
          <template v-slot="{ doc }">
            <PageSeoData :title="doc?.title" />
            <article>
              <h2>{{ doc.title }}</h2>
              <ContentRenderer :value="doc" />
            </article>
          </template>
          <template #not-found></template>
        </ContentDoc>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { NavItem } from "@nuxt/content/dist/runtime/types";
import BaseSelect, {
  BaseSelectOption,
} from "~/components/input/BaseSelect.vue";
import LocLink from "~/components/lang/LocLink.vue";
import getDocumentsData from "~/utils/getDocumentsData";
import PageSeoData from "~/components/pageSeoData/PageSeoData.vue";

const router = useRouter();
const { locale } = useI18n();

const { DOCUMENTS_DATA_ITEMS } = getDocumentsData();

const props = defineProps<{ documentPath: string; documentsParam: string }>();

if (!DOCUMENTS_DATA_ITEMS.includes(props.documentsParam as string)) {
  throw createError({
    statusCode: 404,
    fatal: true,
  });
}

const licenseQuery = queryContent(`${locale.value}/${props.documentsParam}/`);

const selectOptions = ref<BaseSelectOption[] | undefined>([]);
const selectedFile = ref<BaseSelectOption>();

function setSelectOptions(navigation: NavItem[]) {
  const arr = navigation
    .map((e, i) => {
      return {
        id: e._path || i.toString(),
        value: e._path,
      };
    })
    .reverse();
  return arr;
}

function onSelectFile(option: BaseSelectOption) {
  router.push(option.id);
}

function getDate(date: Date): string {
  const localDate = new Date(date);
  const day = localDate.getDate();
  const preparedDay = day.toString().padStart(2, "0");
  const month = localDate.getMonth() + 1;
  const preparedMonth = month.toString().padStart(2, "0");
  const year = localDate.getFullYear();
  return `${preparedDay}.${preparedMonth}.${year}`;
}
</script>
